import { render, staticRenderFns } from "./OverlayOrderbox.vue?vue&type=template&id=04466158&"
import script from "./OverlayOrderbox.vue?vue&type=script&lang=js&"
export * from "./OverlayOrderbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04466158')) {
      api.createRecord('04466158', component.options)
    } else {
      api.reload('04466158', component.options)
    }
    module.hot.accept("./OverlayOrderbox.vue?vue&type=template&id=04466158&", function () {
      api.rerender('04466158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayOrderbox.vue"
export default component.exports